import React from "react";
import {
  Container,
  LeftColumn,
  LeftTextBlock,
  MainWrapper,
  RightColumn,
  Row,
  Title,
  Text,
  PhotoText,
  PhotoBlock,
  PhotosWrapper,
  Quote, NewsTitle,
} from "./main.styles";
import mainWoman from "assets/images/main_woman.jpg";
import mainMan from "assets/images/main_man.jpg";
import mainFamily1 from "assets/images/main_family1.jpg";
import mainFamily2 from "assets/images/main_family2.jpg";
import { useIsMobile } from "hooks";
import MainNews from "components/molecules/MainNews/mainNews";

import { useTranslation } from 'react-i18next';

const MainPage: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Container>
      <MainWrapper>
        <Row>
          <LeftColumn style={{ gap: isMobile ? '24px' : '72px' }}>
            <LeftTextBlock>
              <Title>{t('mainPage.section1.title')}</Title>
              {isMobile && <img src={mainFamily1} alt="main_family1" />}
              <Text style={{ width: isMobile ? '100%' : '80%' }}>
                {t('mainPage.section1.text')}
              </Text>
            </LeftTextBlock>
            <PhotosWrapper>
              <PhotoBlock>
                <img src={mainWoman} alt="main_woman" />
                <PhotoText>{t('mainPage.photoBlock1.text')}</PhotoText>
              </PhotoBlock>
              <PhotoBlock>
                <img src={mainMan} alt="main_man" />
                <PhotoText style={{ width: isMobile ? '100%' : '60%' }}>
                  {t('mainPage.photoBlock2.text')}
                </PhotoText>
              </PhotoBlock>
            </PhotosWrapper>
          </LeftColumn>

          <RightColumn>
            <PhotoBlock>
              {!isMobile && <img src={mainFamily1} alt="main_family1" />}
            </PhotoBlock>
          </RightColumn>
        </Row>

        <Row style={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}>
          <LeftColumn>
            <PhotoBlock>
              <img src={mainFamily2} alt="main_family2" />
              <PhotoText style={{ width: isMobile ? '100%' : '50%' }}>
                {t('mainPage.photoBlock3.text')}
              </PhotoText>
            </PhotoBlock>
          </LeftColumn>

          <RightColumn>
            <LeftTextBlock>
              <Title>{t('mainPage.section2.title')}</Title>
              <Text style={{ width: isMobile ? '100%' : '80%' }}>
                {t('mainPage.section2.text')}
              </Text>
            </LeftTextBlock>
          </RightColumn>
        </Row>

        <Quote>{t('mainPage.quote')}</Quote>
        <NewsTitle>{t('mainPage.newsTitle')}</NewsTitle>
        <MainNews />
      </MainWrapper>
    </Container>
  );
};


export default MainPage;
